/**
 * @generated SignedSource<<c2aa8f1291b6df62ffb4e1ea16f61d45>>
 * @relayHash c8e308b4058efe33c02f04dd0c12cb93
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c8e308b4058efe33c02f04dd0c12cb93

import { ConcreteRequest } from 'relay-runtime';
export type deEpisodeOfCareAiSuggestionsQuery$variables = {
  appointmentId: string;
};
export type deEpisodeOfCareAiSuggestionsQuery$data = {
  readonly suggestedEpisodeOfCareIcdDiagnoses: ReadonlyArray<{
    readonly diagnosisCode: string;
    readonly id: string;
    readonly text: string;
  }>;
};
export type deEpisodeOfCareAiSuggestionsQuery = {
  response: deEpisodeOfCareAiSuggestionsQuery$data;
  variables: deEpisodeOfCareAiSuggestionsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appointmentId"
  }
],
v1 = [
  {
    "alias": "suggestedEpisodeOfCareIcdDiagnoses",
    "args": [
      {
        "kind": "Variable",
        "name": "appointmentId",
        "variableName": "appointmentId"
      }
    ],
    "concreteType": "IcdDiagnosis",
    "kind": "LinkedField",
    "name": "de_suggestedEpisodeOfCareIcdDiagnoses",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "diagnosisCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "text",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deEpisodeOfCareAiSuggestionsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deEpisodeOfCareAiSuggestionsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "c8e308b4058efe33c02f04dd0c12cb93",
    "metadata": {},
    "name": "deEpisodeOfCareAiSuggestionsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f7202dcf4e1400c7146621ac9da4b03f";

export default node;
